import { Control, Controller, FieldErrors } from 'react-hook-form';
import { GraniteLabel } from 'components/V2/Label/GraniteLabel';
import { ErrorSubtext } from 'components/ErrorSubtext/ErrorSubtext';
import MultiOptionButton from 'components/MultiOptionButton';
import FormSection from 'components/FormSection';
import { SpeedEnum } from '../Checkout/schemas';
import { AccessCheckoutForm } from 'api/accessexpressv3/schemas/AccessCheckoutSchemas';

interface ShippingPreferencesProps {
  control: Control<AccessCheckoutForm>;
  errors: FieldErrors<AccessCheckoutForm>;
  currentIndex: number;
  containsOnlyPrimaryCellularProducts: boolean;
  containsNetworkProducts: boolean;
}

export const ShippingPreferences = ({
  control,
  errors,
  currentIndex,
  containsOnlyPrimaryCellularProducts,
  containsNetworkProducts,
}: ShippingPreferencesProps) => {
  const hasErrors = errors.locations?.[currentIndex]?.speed;

  return (
    <FormSection title="Shipping preferences" gridClassName="grid-cols-1">
      <GraniteLabel
        label="Speed"
        subtitle="Shipping charges may increase based on the weight of the package."
        className="relative col-start-1 -mb-6"
      />
      <Controller
        name={`locations.${currentIndex}.speed`}
        control={control}
        render={({ field: { onChange, value } }) => (
          <div>
            <div className="grid gap-4 sm:grid-cols-3">
              {!containsOnlyPrimaryCellularProducts && (
                <MultiOptionButton
                  label="Standard / ground"
                  option={SpeedEnum.enum.Standard}
                  value={value}
                  onClick={onChange}
                  subText="Ships within 5 business days"
                  className="!justify-start"
                  variant="blue"
                />
              )}
              {!containsNetworkProducts && (
                <MultiOptionButton
                  label="2 business-day"
                  option={SpeedEnum.enum.TwoBusinessDay}
                  value={value}
                  onClick={onChange}
                  subText="Ships within 2 business days"
                  className="!justify-start"
                  variant="blue"
                />
              )}
              <MultiOptionButton
                label="Overnight"
                option={SpeedEnum.enum.Overnight}
                value={value}
                onClick={onChange}
                subText="Ships within 1 business day"
                className="!justify-start"
                variant="blue"
              />
            </div>

            {hasErrors && (
              <ErrorSubtext
                className="-mt-2"
                error="Selecting a speed is required"
                withTopMargin={false}
              />
            )}
          </div>
        )}
      />
    </FormSection>
  );
};
